module.exports = __webpack_public_path__ + "static/media/onesland.e45f1d46.mp4";